// Tiny event bus for "the user just got value from Vent" moments.
// Used to time the notification pre-permission screen and review requests.
import { subscribeWellnessLog } from './wellnessLogBus';

export type MeaningfulAction = 'room_join' | 'vent_posted' | 'reply_posted' | 'wellness_logged';
export type ReviewMoment = 'weekly_review' | 'badge' | 'streak' | 'engagement';

type ActionListener = (a: MeaningfulAction) => void;
type MomentListener = (m: ReviewMoment) => void;

const actionListeners = new Set<ActionListener>();
const momentListeners = new Set<MomentListener>();

export function emitMeaningfulAction(a: MeaningfulAction) {
  actionListeners.forEach((l) => { try { l(a); } catch { /* noop */ } });
}
export function onMeaningfulAction(l: ActionListener) {
  actionListeners.add(l);
  const unsubWellness = subscribeWellnessLog(() => l('wellness_logged'));
  return () => { actionListeners.delete(l); unsubWellness(); };
}

/** Fire AFTER a positive moment has finished (celebration closed, etc.). */
export function emitReviewMoment(m: ReviewMoment) {
  momentListeners.forEach((l) => { try { l(m); } catch { /* noop */ } });
}
export function onReviewMoment(l: MomentListener) {
  momentListeners.add(l);
  return () => { momentListeners.delete(l); };
}
